import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


// Register Service Worker for PWA Installation Support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swUrl = (process.env.PUBLIC_URL || '') + '/service-worker.js';
    navigator.serviceWorker.register(swUrl)
      .then(reg => console.log('PWA ServiceWorker registered successfully:', reg.scope))
      .catch(err => console.log('PWA ServiceWorker registration failed:', err));
  });
}
